import { render } from "./CreateReleasePage.vue?vue&type=template&id=15aabdb0"
import script from "./CreateReleasePage.vue?vue&type=script&lang=js"
export * from "./CreateReleasePage.vue?vue&type=script&lang=js"

import "./CreateReleasePage.vue?vue&type=style&index=0&id=15aabdb0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__